export default __webpack_public_path__ + "static/piggyBankOnCalculator-a8a4f36f188b811d3278bfaced854923.webp";